export namespace PandemieConstants {
    export const BOUNDED_CONTEXT_NAME = 'Pandemie';
    export const PANDEMIE_LIZENZ_MODUL = 'pandemie';
    
}

